var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcnTime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    viewBox: "0 0 14 15",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.7625
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.16614,
    cy: 7.25732,
    rx: 5.83411,
    ry: 5.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.16602 4.31982v2.9375l1.75023 1.7625",
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcnTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icn-time.74fb76990d9baceeae6fc25a5981bc01.svg";